/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Marienschule_Offenbach2Inputs */

const en__field_enum_marienschule_offenbach2 = /** @type {(inputs: _Field_Enum_Marienschule_Offenbach2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offenbach`)
};

const de__field_enum_marienschule_offenbach2 = /** @type {(inputs: _Field_Enum_Marienschule_Offenbach2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marienschule`)
};

/**
* | output |
* | --- |
* | "Offenbach" |
*
* @param {_Field_Enum_Marienschule_Offenbach2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_marienschule_offenbach2 = /** @type {((inputs?: _Field_Enum_Marienschule_Offenbach2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Marienschule_Offenbach2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_marienschule_offenbach2(inputs)
	return de__field_enum_marienschule_offenbach2(inputs)
});
export { _field_enum_marienschule_offenbach2 as "_field_enum_Marienschule_Offenbach" }